import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';
import { MobizSettings } from '../data/mobiz-settings.do';
import { SynchronizationSettings } from '../data/synchronization-settings.do';

export interface ISynchronizationSettingsService {
  get(
    organizationId: string,
  ): Observable<MobizSettings<SynchronizationSettings>>;

  set(
    organizationId: string,
    settingsValue: MobizSettings<SynchronizationSettings>,
  ): Observable<MobizSettings<SynchronizationSettings>>;
}

export const ISynchronizationSettingsService = new InjectionToken('ISynchronizationSettingsService');
